function SessionHistoryManager() {
    const tabId = sessionStorage.tabId || Math.random().toString(36).substr(2, 9);
    sessionStorage.tabId = tabId;

    const historyKey = "tabHistory_" + tabId;
    let currentHistory = JSON.parse(sessionStorage.getItem(historyKey)) || { prev: null, actual: null };

    const currentUrl = window.location.href;

    if (currentUrl !== currentHistory.actual) {
        currentHistory = {
            prev: currentHistory.actual,
            actual: currentUrl
        };
        sessionStorage.setItem(historyKey, JSON.stringify(currentHistory));
    }
}

module.exports = SessionHistoryManager;
